import './WhatAreYouLookingFor.css';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import  WhatAreYouLookingForFirstOptions from './WhatAreYouLookingForFirstOptions';
import  WhatAreYouLookingForNBeds from './WhatAreYouLookingForNBeds';
import  WhatAreYouLookingForFeatures from './WhatAreYouLookingForFeatures';
import  WhatAreYouLookingForPrice from './WhatAreYouLookingForPrice';
import  WhatAreYouLookingForHouseType from './WhatAreYouLookingForHouseType';
import  WhatAreYouLookingForViewModel from '../view_models/WhatAreYouLookingForViewModel';
import  ContentType from './WhatAreYouLookingForContentType';
export default class WhatAreYouLookingFor{
	constructor({}){
		this._setContent = this._setContent.bind(this);
		this._element = document.createElement('div');
		this._element.classList.add('what-are-you-looking-for');
		this._visibleChanged = this._visibleChanged.bind(this);
		this.initialize = this.initialize.bind(this);
	}
	initialize({siteJsons, houseTypesViewModel, setFilterInSite}){
		this._whatAreYouLookingForViewModel = new WhatAreYouLookingForViewModel({siteJsons,
			houseTypesViewModel, setFilterInSite});
		this._titleElement = document.createElement('div');
		this._titleElement.classList.add('title');
		this._element.appendChild(this._titleElement);
		this._titleElement.innerHTML = 'What are you looking for?';
		this._contentElement = document.createElement('div');
		this._contentElement.classList.add('content');
		this._element.appendChild(this._contentElement);
		this._whatAreYouLookingForNBeds = new WhatAreYouLookingForNBeds({
			siteJsons,
			whatAreYouLookingForViewModel:this._whatAreYouLookingForViewModel
		});
		this._whatAreYouLookingForFeatures = new WhatAreYouLookingForFeatures({
			siteJsons,
			whatAreYouLookingForViewModel:this._whatAreYouLookingForViewModel
		});
		this._whatAreYouLookingForPrice = new WhatAreYouLookingForPrice({
			siteJsons,
			whatAreYouLookingForViewModel:this._whatAreYouLookingForViewModel
		});
		this._whatAreYouLookingForHouseType = new WhatAreYouLookingForHouseType({
			siteJsons, 
			houseTypesViewModel,
			whatAreYouLookingForViewModel:this._whatAreYouLookingForViewModel
		});
		this._whatAreYouLookingForFirstOptions = new WhatAreYouLookingForFirstOptions({
			nBeds:this._whatAreYouLookingForNBeds,
			price:this._whatAreYouLookingForPrice,
			houseType:this._whatAreYouLookingForHouseType,
			features:this._whatAreYouLookingForFeatures,
			whatAreYouLookingForViewModel:this._whatAreYouLookingForViewModel
		});
		this._setContent(ContentType.FirstOptions);
		this._propertyBindingPriceRange = PropertyBindingFactory.standard(this, this._whatAreYouLookingForViewModel,
			'visible',
			this._visibleChanged);
	}
	_visibleChanged(value){
		if(value)
			this._element.classList.add('visible');
		else 
			this._element.classList.remove('visible');
	}
	_setContent(contentType){
		if(this._currentContentElement){
			this._element.removeChild(this._currentContentElement);
		}
		var newContentElement;
		switch(contentType){
			case ContentType.FirstOptions:
				newContentElement = this._whatAreYouLookingForFirstOptions.element;
			break;
			default:
				throw new Error('Not implemented');
		}
		this._contentElement.appendChild(newContentElement);
	}
	get element(){
		return this._element;
	}
}